module.exports = __webpack_public_path__ + "img/full-map.ab6e1540.jpg";